import {
  ActionReducerMapBuilder,
  EntityState,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import { ThunkExtra } from '@app/store';
import { Link, DashboardService } from '@app/gen/dashboard';
import { DynamicEntity } from '@app/types';

import { DashboardState } from '../../dashboard.state';

export const getElectronicServices = createAsyncThunk<
  Link[],
  undefined,
  ThunkExtra
>(
  'dashboard/getElectronicServices',
  async (_, { rejectWithValue, extra: { inject } }) => {
    try {
      const service = inject(DashboardService);

      const result = await service.getUserWidgetLinks();

      return result.links;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const electronicServicesReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getElectronicServices.pending, (state) => {
    state.electronicServices.status = 'loading';
  });
  builder.addCase(getElectronicServices.fulfilled, (state, { payload }) => {
    state.electronicServices.status = 'complete';
    state.electronicServices.items = payload;
  });
  builder.addCase(getElectronicServices.rejected, (state) => {
    state.electronicServices.status = 'failed';
  });
};
